import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

export interface RTab {
    key: string;
    label: string;
    icon?: React.ComponentType<{ sx?: object }>;
    badge?: number;
}

interface RTabsProps {
    tabs: RTab[];
    activeTab: string;
    onTabChange: (key: string) => void;
}

export function RTabs({ tabs, activeTab, onTabChange }: RTabsProps) {
    return (
        <TabsContainer>
            {tabs.map((tab) => {
                const active = tab.key === activeTab;
                return (
                    <TabButton key={tab.key} active={active} onClick={() => onTabChange(tab.key)}>
                        {tab.icon && <tab.icon sx={{ fontSize: 18 }} />}
                        {tab.label}
                        {tab.badge != null && tab.badge > 0 && <TabBadge>{tab.badge}</TabBadge>}
                    </TabButton>
                );
            })}
        </TabsContainer>
    );
}

const TabsContainer = styled('div')({
    display: 'inline-flex',
    gap: 4,
    padding: 4,
    borderRadius: 10,
    backgroundColor: Colors.lightGrey,
    marginBottom: 24,
});

const TabButton = styled('button')<{ active: boolean }>(({ active }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '8px 20px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    borderRadius: 8,
    border: active ? `1px solid ${Colors.lightGrey}` : '1px solid transparent',
    backgroundColor: active ? Colors.white : 'transparent',
    color: active ? Colors.darkNavy : Colors.mediumGrey,
    boxShadow: active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
    outline: 'none',
    transition: 'all 0.15s',
    '&:hover': {
        color: Colors.darkNavy,
    },
    '&:focus, &:focus-visible': {
        outline: 'none',
    },
}));

const TabBadge = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 22,
    height: 22,
    padding: '0 6px',
    borderRadius: 11,
    fontSize: 12,
    fontWeight: 600,
    backgroundColor: Colors.turquoise,
    color: Colors.white,
});
